module.exports = __webpack_public_path__ + "static/media/my-profile.ac51c5ac.svg";